export default function (value) {
    var strongRegex = new RegExp("^(?=.*[a-zA-Z])(?=.*[0-9])(?=.{6,})");
    return strongRegex.test(value);
}
